import { usePermissionStore } from "@/store/permission-store";
import type { IPermission } from "@/types/permission-types";

export const can = (permission: IPermission | string | undefined): boolean => {
  const permissionStore = usePermissionStore();
  const permissions: IPermission[] = permissionStore.permissions || [];
  return permissions.includes(permission as IPermission);
};
